import React, { useEffect, useState } from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import API_URL from "../../config/constant";

export default function Faq() {
    const [currentIndex, setCurrentIndex] = useState(null);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/faq?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res);
            } catch (error) {
                setData(t("faq", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <div className="text-white md:px-0 px-4 relative z-30">
            <div className="relative min-h-[240px] lg:min-h-[300px] bg-brand-blue bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={"Frequently Asked Question"} />
            </div>
            {/* <ComingSoonBanner /> */}
            <div className="top-0 md:top-40 lg:top-60 relative bg-white 2xl:px-0 md:px-14 pb-36 md:pb-48 lg:pb-96 2xl:pb-44 lg:mb-24">
                <div className="bg-white min-h-screen container mx-auto px-4 w-full font-poppins text-[#164481]">
                    {data?.map((value, index) => (
                        <div
                            key={index}
                            className="py-10 border-b border-neutral-600 w-full"
                        >
                            <div className="w-full flex items-center justify-between hover:cursor-pointer" onClick={() =>
                                index === currentIndex
                                    ? setCurrentIndex(null)
                                    : setCurrentIndex(index)
                            }>
                                <h1 className="md:text-2xl text-xl uppercase font-bold">{value.title}</h1>
                                <button>
                                    {index === currentIndex ? (
                                        <MinusIcon width={24} className="text-[#164481]" />
                                    ) : (
                                        <PlusIcon width={24} className="text-[#164481]" />
                                    )}
                                </button>
                            </div>
                            <div
                                className={`mt-4 w-full ${index === currentIndex ? "block" : "hidden"
                                    }`}
                            >
                                <ul className="space-y-4 w-full">
                                    {value.data.map((data, i) => (
                                        <li className="space-y-2 w-full">
                                            <h2 className="font-medium text-lg">
                                                {i + 1}. {data.question}
                                            </h2>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: data?.answer }}
                                                className="font-light text-[#164481]"
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
